'use strict';
import React from 'react';
import {RouteHandler} from 'react-router';
import Header from 'components/header/header';
import Offcanvas from 'components/offcanvas/offcanvas';
import AltContainer from 'alt-container';
import ModalContainer from 'components/modals';

var AppPage = React.createClass({
    displayName: 'AppPage',

    mixins: [],

    propTypes: {},

    componentWillMount() {
        if ( this.props.flux.getStore('app').isAuthenticated() ) {
            // Prevent Double fetching
            // @todo: this isn't the cleanest option...
            if (
                this.props.pathname.indexOf('baskets') === -1 &&
                this.props.pathname.indexOf('downloads')
            ) {
                const basketStore = this.props.flux.getStore('basket');
                !basketStore.isLoading() && basketStore.loadBaskets();
            }
        }
    },

    render() {
        const { flux } = this.props;

        return (
            <div>
                <AltContainer
                    stores={{
                        appStore:    flux.getStore('app'),
                        basketStore: flux.getStore('basket')
                    }}
                    transform={({ appStore, basketStore }) => {
                        let isAuthenticated        = flux.getStore('app').isAuthenticated();
                        let hasAcceptedLatestTerms = flux.getStore('app').hasAcceptedLatestTerms();
                        let activeBasketId         = basketStore.activeBasketId;
                        let baskets                = basketStore.baskets;
                        return { isAuthenticated, hasAcceptedLatestTerms, activeBasketId, baskets };
                    }}>
                    <Header />
                    <Offcanvas />
                </AltContainer>
                <RouteHandler {...this.props} />
                <AltContainer stores={{ modalStore: flux.getStore('modals') }}>
                    <ModalContainer />
                </AltContainer>
            </div>
        );
    }
});

module.exports = AppPage;



// WEBPACK FOOTER //
// ./app/pages/app.jsx